import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
    baseURL: '/api',
    timeout: 250000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        // const token = localStorage.getItem('token')
        // if (token) {
        //     config.headers['Authorization'] = `Bearer ${token}`
        // }
        
        // 自动添加会话ID
        const conversationId = localStorage.getItem('conversationId')
        if (conversationId) {
            config.headers['X-Conversation-ID'] = conversationId
        }
        
        return config
    },
    error => {
        // 对请求错误做些什么
        console.error('请求错误：', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
   response => {
        const res = response.data
        // 如果返回的状态码不是200，说明接口请求有误
        //if (res.code !== 200 && res.code !== 1) {
        if (res.code >=250) {
            // 如果是 503 服务不可用，跳转到服务不可用页面
            if (res.code === 503) {
                window.location.href = '/service-unavailable.html'
                return Promise.reject(new Error(res.message || '服务不可用'))
            }
            ElMessage({
                message: res.message || '请求失败',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(res.message || '请求失败'))
        } else {
            return res
        }
    },
    error => {
        console.error('响应错误：', error)
        ElMessage({
            message: error.message || '请求失败',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service